<template>
  <!-- <Uploader txt='textoDoBotao' icon="iconDoBotao" @getSelectedFile="file = $event"/>
include this tag in parent component for rendering uploader button customized here
include 'file' in the parent component's data to receive the selected file
  url = URL.createObjectURL(file); // preview uploaded-->
  <div>
    <input
      style="display: none"
      type="file"
      accept="image/png, image/jpeg"
      @change="onSelected"
      ref="fileInput"
    />

    <!-- customize btn here -->
    <v-btn @click="$refs.fileInput.click()" block round large color="white" class="primary--text">
      <v-icon left>{{icon}}</v-icon>
      {{txt}}
    </v-btn>
  </div>
</template>

<script>
export default {
  props: ["txt", "icon"],
  data() {
    return {};
  },
  methods: {
    onSelected(event) {
      const selectedFile = event.target.files[0];
      const megas = 5;
      if (selectedFile.size > megas * 1024 * 1024) {
        event.preventDefault();
        alert(
          "Limite de tamanho excedido! Escolha uma imagem menor (máx: " +
            megas +
            "mb)"
        );
        return;
      }
      this.getBase64(selectedFile).then(img => {
        this.$emit("getSelectedFile", img);
      }); // SEND TO PARENT);
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function() {
          resolve(reader.result);
        };
        reader.onerror = function(error) {
          console.log("Error: ", error);
          reject(error);
        };
      });
    }
  }
};
</script>